var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar2 = function SvgStar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m23.785 8.545-6.503-1.557L13.25.5c-.414-.667-1.086-.667-1.5 0L7.718 6.988 1.215 8.545c-.741.178-.938.808-.44 1.408l4.8 5.77-.734 7.204c-.08.79.445 1.243 1.173 1.013l6.486-2.054 6.486 2.054c.728.23 1.253-.223 1.172-1.012l-.734-7.204 4.8-5.771c.5-.6.302-1.23-.44-1.408"
  })));
};
export default SvgStar2;